import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum RefundStatusOperation {
  Open = 1,
  Approved = 2,
  Denied = 3,
  Failed = 5,
}
EnumDescriptions.setDescriptions(RefundStatusOperation, [
  i18n.t('enums.waiting_for_approval'),
  i18n.t('enums.request_approved'),
  i18n.t('enums.request_denied'),
  i18n.t('enums.request_failed'),
]);
